import { Filter, X } from 'lucide-preact';
import { GEOSPATIAL_PAGE } from './geospatial.config';

interface GeospatialFiltersFabProps {
  open: boolean;
  onToggle: () => void;
}

export function GeospatialFiltersFab({ open, onToggle }: GeospatialFiltersFabProps) {
  return (
    <button
      type="button"
      className="geo-filters-fab geospatial-filters-fab"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={open ? 'Close filters' : 'Open filters'}
      title={open ? 'Close filters' : 'Open filters'}
    >
      {open ? <X size={18} aria-hidden /> : <Filter size={18} aria-hidden />}
      <span className="geo-filters-fab__label geospatial-filters-fab__label">
        {open ? GEOSPATIAL_PAGE.filtersCloseLabel : GEOSPATIAL_PAGE.filtersLabel}
      </span>
    </button>
  );
}
